import * as React from 'react';

import { RadioGroupOption } from 'shared/newEntities/components/Radio';
import { WithMetaProps } from 'shared/newEntities/components/WithMeta';
import WithMeta from 'shared/newComponents/form/WithMeta';

import Radio from './Radio';

import './RadioGroup.modules.scss';

type Props<T extends string> = Omit<WithMetaProps, 'reference'> & {
  name: string;
  value: T | null;
  options: RadioGroupOption<T>[];
  onChange: (id: T) => void;
  disabled?: boolean;
  /** Оформление отдельного пункта: карточка, отступы внутри */
  itemClassName?: string;
  className?: string;
  ariaLabel?: string;
};

/**
 * Единственный выбор из нескольких вариантов. Роль и подпись принадлежат группе,
 * поэтому ошибка тоже показывается на ней, а не на отдельной кнопке.
 */
const RadioGroup = <T extends string>({
  name,
  value,
  options,
  onChange,
  disabled = false,
  itemClassName,
  className,
  ariaLabel,
  ...metaProps
}: Props<T>): React.ReactElement => {
  return (
    <WithMeta {...metaProps}>
      <div
        styleName="radio-group"
        className={className}
        role="radiogroup"
        aria-label={ariaLabel}
      >
        {options.map((option) => (
          <Radio
            key={option.id}
            name={name}
            value={option.id}
            checked={value === option.id}
            disabled={disabled || option.disabled}
            className={itemClassName}
            onChange={() => onChange(option.id)}
          >
            {option.label}
          </Radio>
        ))}
      </div>
    </WithMeta>
  );
};

export default RadioGroup;
